module.exports = __webpack_public_path__ + "static/media/masonary_02.99090e73.png";